'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef, useState } from 'react';
import { Typography } from '@/components/Typography';
import { PhosphorIcon } from '@/components/icons/PhosphorIcon';
import { cn } from '@/lib/cn';
import type { FilterProps } from './types';
interface FilterDrawerProps extends FilterProps {
  topDrawerId: string;
}
export const getDrawerFilterIdFromTitle = (title: string) => `drawer-filter-${title}`;
export function FilterDrawer(t0) {
  const $ = _c(61);
  const {
    clear,
    items,
    title,
    toggle,
    topDrawerId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [toggled, setToggled] = useState(t1);
  const inputRef = useRef(null);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => inputRef.current?.click();
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const closeDrawer = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = label => setToggled(prev => prev.includes(label) ? prev.filter(l => l !== label) : [...prev, label]);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const toggleSelected = t3;
  let t4;
  if ($[3] !== clear) {
    t4 = () => {
      setToggled([]);
      clear?.();
    };
    $[3] = clear;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const clearAll = t4;
  let t5;
  if ($[5] !== toggle || $[6] !== toggled) {
    t5 = () => {
      toggle(toggled);
      setToggled([]);
      closeDrawer();
    };
    $[5] = toggle;
    $[6] = toggled;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const apply = t5;
  let t6;
  if ($[8] !== title) {
    t6 = getDrawerFilterIdFromTitle(title);
    $[8] = title;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const drawerId = t6;
  const t7 = `Toggle ${title}`;
  let t8;
  if ($[10] !== drawerId || $[11] !== t7) {
    t8 = <input id={drawerId} data-testid="drawer-filter-input" type="checkbox" className="drawer-toggle" ref={inputRef} aria-label={t7} />;
    $[10] = drawerId;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== apply || $[14] !== topDrawerId) {
    t9 = <label htmlFor={topDrawerId} className="drawer-overlay w-full" onClick={apply} />;
    $[13] = apply;
    $[14] = topDrawerId;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <PhosphorIcon className="text-[24px]" name="arrow-left" />;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== apply) {
    t11 = <button onClick={apply}>{t10}</button>;
    $[17] = apply;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== title) {
    t12 = <Typography variant="h6" className="flex grow gap-2 justify-center">{title}</Typography>;
    $[19] = title;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <PhosphorIcon className="text-[24px]" name="x" />;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== apply || $[23] !== topDrawerId) {
    t14 = <label htmlFor={topDrawerId} onClick={apply}>{t13}</label>;
    $[22] = apply;
    $[23] = topDrawerId;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t11 || $[26] !== t12 || $[27] !== t14) {
    t15 = <div className="border-b-1 border-base-300 px-6 py-4 flex flex-row justify-between items-center">{t11}{t12}{t14}</div>;
    $[25] = t11;
    $[26] = t12;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== items || $[30] !== title || $[31] !== toggled) {
    let t17;
    if ($[33] !== title || $[34] !== toggled) {
      t17 = t18 => {
        const {
          isChecked,
          label: label_0
        } = t18;
        const isToggled = toggled.includes(label_0);
        const itemId = `drawer-${title}-${label_0}`;
        return <label htmlFor={itemId} className="flex flex-row gap-2 items-center cursor-pointer" key={itemId}><input checked={isToggled ? !isChecked : isChecked} className={cn("checkbox !rounded-[4px]", {
            "border-primary": isToggled && isChecked,
            "border-secondary": isToggled && !isChecked
          })} id={itemId} onChange={() => toggleSelected(label_0)} type="checkbox" /><Typography variant="h6" className="grow text-left text-nowrap font-semibold">{label_0}</Typography></label>;
      };
      $[33] = title;
      $[34] = toggled;
      $[35] = t17;
    } else {
      t17 = $[35];
    }
    t16 = items.map(t17);
    $[29] = items;
    $[30] = title;
    $[31] = toggled;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[36] !== t16) {
    t17 = <div className="px-6 py-8 flex flex-col gap-8 w-full bg-white grow shrink overflow-y-auto">{t16}</div>;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== clearAll) {
    t18 = <button className="btn bg-white text-primary pl-8 pr-7 border-primary h-13" onClick={clearAll}>Clear all</button>;
    $[38] = clearAll;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  const t19 = toggled.length > 0;
  const t20 = toggled.length === 0;
  let t21;
  if ($[40] !== t19 || $[41] !== t20) {
    t21 = cn("btn pl-8 pr-7 h-13", {
      "btn-primary": t19,
      "btn-neutral": t20
    });
    $[40] = t19;
    $[41] = t20;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  const t22 = toggled.length ? ` (${toggled.length})` : null;
  let t23;
  if ($[43] !== apply || $[44] !== t21 || $[45] !== t22 || $[46] !== topDrawerId) {
    t23 = <label htmlFor={topDrawerId} className={t21} onClick={apply}>Apply{t22}</label>;
    $[43] = apply;
    $[44] = t21;
    $[45] = t22;
    $[46] = topDrawerId;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== t18 || $[49] !== t23) {
    t24 = <div className="flex justify-center px-6 py-4 bg-white w-full card-shadow-t gap-4">{t18}{t23}</div>;
    $[48] = t18;
    $[49] = t23;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] !== t15 || $[52] !== t17 || $[53] !== t24) {
    t25 = <div className="relative flex flex-col bg-white h-full w-[94vw]">{t15}{t17}{t24}</div>;
    $[51] = t15;
    $[52] = t17;
    $[53] = t24;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  let t26;
  if ($[55] !== t25 || $[56] !== t9) {
    t26 = <div className="drawer-side" tabIndex={0}>{t9}{t25}</div>;
    $[55] = t25;
    $[56] = t9;
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  let t27;
  if ($[58] !== t26 || $[59] !== t8) {
    t27 = <div className="drawer bg-white z-101 md:hidden">{t8}{t26}</div>;
    $[58] = t26;
    $[59] = t8;
    $[60] = t27;
  } else {
    t27 = $[60];
  }
  return t27;
}